module.exports = __webpack_public_path__ + "img/monolisa-light.e350ec83.png";